import { useContext } from "react";
import { TrfSearchContextAPI } from "../context/TrfSearchContext";

const useTrfSearchContext = () => {
  const context = useContext(TrfSearchContextAPI);
  return context
};

export default useTrfSearchContext;
